import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class GooglePlaceSuggestion extends BaseModel {
  /**
   * @var {string}
   */
  description;

  /**
   * @var {string}
   */
  placeId;

  constructor(model = {}) {
    super();

    this.description = model.description;
    /**
     * @var {string} place_id
     */
    this.placeId = model.place_id;
  }

  /**
   * @returns {string}
   */
  static get autoCompleteDisplayProperty() {
    return 'description';
  }
}
